
import { Component, Prop, Vue } from 'vue-property-decorator';

let uid = 0;

@Component
export default class PrivacyConsent extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) consentText!: string;
  @Prop({ default: '' }) error!: string;
  @Prop({ default: false }) showError!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: 'privacy' }) name!: string;

  private readonly uid = uid++;

  get inputId(): string {
    return `privacy-consent-${this.uid}`;
  }
}
